import { lazy } from 'react';

const MaterialSaleRecordsTransformerConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/transformer/consult/material-sale-records',
			component: lazy(() => import('./MaterialSaleRecordsContainer'))
		}
	]
};

export default MaterialSaleRecordsTransformerConfig;
